module.exports = __webpack_public_path__ + "img/classroom-2.8fc59253.png";